import React from 'react';
import { CalendarDaysIcon, ClockIcon } from '@heroicons/react/24/outline';

const CandidateStatsCards = ({ candidateStats }) => {
  const stats = [
    { label: 'Today', count: candidateStats.today, icon: ClockIcon, iconClass: 'text-emerald-500' },
    { label: 'Yesterday', count: candidateStats.yesterday, icon: ClockIcon, iconClass: 'text-sky-500' },
    { label: 'Last 3 Days', count: candidateStats.last3Days, avg: candidateStats.avgPerDay3, icon: CalendarDaysIcon, iconClass: 'text-green-500' },
    { label: 'Last 7 Days', count: candidateStats.last7Days, avg: candidateStats.avgPerDay7, icon: CalendarDaysIcon, iconClass: 'text-blue-500' },
    { label: 'Last 30 Days', count: candidateStats.last30Days, avg: candidateStats.avgPerDay30, icon: CalendarDaysIcon, iconClass: 'text-indigo-500' },
    { label: 'Last 90 Days', count: candidateStats.last90Days, avg: candidateStats.avgPerDay90, icon: CalendarDaysIcon, iconClass: 'text-purple-500' }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-white shadow rounded-lg px-4 py-3 min-h-[104px]">
          <div className="flex items-center gap-2 mb-2 min-w-0">
            <stat.icon className={`h-4 w-4 ${stat.iconClass} flex-shrink-0`} />
            <h3 className="text-xs font-medium text-gray-500 truncate">{stat.label}</h3>
          </div>
          <p className="text-xl font-bold text-gray-900">{stat.count ?? 0}</p>
          {stat.avg !== undefined && (
            <p className="text-[11px] text-gray-500 mt-1">{stat.avg} avg/day</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default CandidateStatsCards;
